import React, {useEffect, useState} from 'react'
import {Routes, Route, Navigate, Outlet} from 'react-router-dom'
import EstampRequestWrapper from './EstampRequestWrapper'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import Swal from 'sweetalert2'
import PendingRequests from './PendingRequests'
import {getAllEstampRequests} from './EstampRequestAPI'
import styles from './EstampStyles/EstampStyle.module.scss'
import {listRequestsDataType} from './EstampRequestDataType'

const profileBreadCrumbs: Array<PageLink> = [
  {title: 'eStamp Requests', path: '/lead-dashboard', isSeparator: false, isActive: false},
  {title: '', path: '', isSeparator: true, isActive: false},
]

const EstampRequestRoute = () => {
  const [requestStatus, setRequestStatus] = useState<number>(2)
  const [listRequests, setListRequests] = useState<listRequestsDataType[]>()
  const [noErequestFound, setNoErequestFound] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [lastUpdated, setLastUpdated] = useState<Date | null>(null)

  // function to get add leads form link (jotform link)
  const getListEstamp = async () => {
    setLoading(true)
    try {
      const {data: response} = await getAllEstampRequests(requestStatus)
      if (response.code === '200') {
        setLastUpdated(new Date())
        setNoErequestFound(false)
        setListRequests(response.data)
      } else if (response.code === '204') {
        setLastUpdated(new Date())
        setNoErequestFound(true)
        setListRequests(response.data)
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
          text: response.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    } finally {
      setLoading(false)
    }
  }

  // onload fetch the add leads form link (jotform link)
  useEffect(() => {
    getListEstamp()
  }, [requestStatus])

  // function to set the color for kyc status in all kyc table
  const setBadgeColor = (statusCode: number) => {
    switch (statusCode) {
      case 0:
        // for pending
        return 'badge-light-warning'
      case 1:
        // for Completed
        return 'badge-light-success'
      case 2:
        // for Awaited signing
        return `${styles.status_processing}`
      default:
        return 'badge-light-warning'
    }
  }
  // function to format the date
  function formatDate(date: Date): string {
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      day: '2-digit',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    }
    return new Intl.DateTimeFormat('en-US', options).format(date)
  }
  return (
    <>
      <Routes>
        {/* Begin: main route for lead management */}
        <Route
          element={
            <>
              <EstampRequestWrapper setRequestStatus={setRequestStatus} />
              <Outlet />
            </>
          }
        >
          {/* Begin: Child route for pending_requests */}
          <Route
            path='pending_requests'
            element={
              <>
                <PageTitle breadcrumbs={profileBreadCrumbs}>Pending Requests</PageTitle>
                <PendingRequests
                  loading={loading}
                  listRequests={listRequests}
                  noErequestFound={noErequestFound}
                  setBadgeColor={setBadgeColor}
                  formatDate={formatDate}
                  requestStatus={requestStatus}
                  getListEstamp={getListEstamp}
                  lastUpdated={lastUpdated}
                />
              </>
            }
          />
          {/* End: Child route for pending_requests */}
          {/* Begin: Child route for completed_requests */}
          <Route
            path='completed_requests'
            element={
              <>
                <PageTitle breadcrumbs={profileBreadCrumbs}>Completed Requests</PageTitle>
                <PendingRequests
                  loading={loading}
                  listRequests={listRequests}
                  noErequestFound={noErequestFound}
                  setBadgeColor={setBadgeColor}
                  formatDate={formatDate}
                  requestStatus={requestStatus}
                  getListEstamp={getListEstamp}
                  lastUpdated={lastUpdated}
                />
              </>
            }
          />
          {/* End: Child route for completed_requests */}
        </Route>
        {/* End: main route for lead management */}
        <Route index element={<Navigate to={`/estamp_request/pending_requests`} />} />
        <Route path='*' element={<Navigate to='/404' />} />
      </Routes>
    </>
  )
}

export default EstampRequestRoute
